// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Input, Modal } from "antd";
import { WarningOutlined } from "@ant-design/icons/lib";
import { formItemBlockLayout } from "../../../../utils/Constant";
import { requestWorkflowSurvey } from "../../../../state/survey/SurveysEffects";
import {
  SurveyRefusedFormProps,
  SurveyWorkflowStatus
} from "../../../types/SurveyTypes";

export const SurveyRefusedPublicationButton: React.FunctionComponent<SurveyRefusedFormProps> = (
  props: SurveyRefusedFormProps
) => {
  const { t } = useTranslation();
  const { surveyId } = props;
  const [visible, setVisible] = useState<boolean>(false);

  const handleSubmit = (values: any) => {
    requestWorkflowSurvey({
      id: surveyId,
      dto: {
        status: SurveyWorkflowStatus.REFUSED,
        readingNotes: values.readingNotes
      }
    });
  };

  return (
    <>
      <Button
        type="default"
        className="btn-warning m-2"
        onClick={() => setVisible(true)}
      >
        <WarningOutlined />
        {t("edit_survey.refuse.text")}
      </Button>
      <Modal
        title={t("edit_survey.refuse.modal.title")}
        okText={t("global.confirm")}
        okButtonProps={{
          form: "survey_refused_publication_form",
          htmlType: "submit"
        }}
        onCancel={() => setVisible(false)}
        cancelText={t("global.cancel")}
        visible={visible}
        centered
      >
        <Form
          id="survey_refused_publication_form"
          {...formItemBlockLayout}
          onFinish={handleSubmit}
        >
          <Form.Item
            name="readingNotes"
            label={
              <span>{t("edit_survey.refuse.modal.reading_notes.title")}</span>
            }
            rules={[
              {
                required: true,
                message: t("global.empty_error_field"),
                whitespace: true
              }
            ]}
          >
            <Input.TextArea
              id="readingNotes"
              placeholder={t(
                "edit_survey.refuse.modal.reading_notes.placeholder"
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
